import { createMeStoppedIndustrializationNotification } from './createMeStoppedIndustrializationNotification';
import { getRowsTransitionedToMeDoneNo } from './meDoneTransitions';

type ProfitCenterOption = { label: string; value: number };

export type ProcessMeStoppedNotificationsParams = {
  editedRow: any[];
  editedRowOriginal: Record<string, Record<string, unknown>>;
  allAccessibleColumns: any[];
  hasMeRole: boolean;
  screenGridId: number;
  createdBy: number;
  configSchema: string;
};

/**
 * Returns the configured value-option IDs for `erledigt_me` (YES and NO).
 */
function getMeDoneStateIds(allAccessibleColumns: any[]) {
  const workPrepDoneValueOptions = allAccessibleColumns.find(
    (col) => col.attrInternalName === 'erledigt_me',
  )?.valueOptions ?? [];

  const yesId = workPrepDoneValueOptions.find((item: any) => item.label.toLowerCase() === 'yes')?.value ?? null;
  const noId = workPrepDoneValueOptions.find((item: any) => item.label.toLowerCase() === 'no')?.value ?? null;

  return { yesId, noId };
}

/**
 * Creates "ME Stopped Industrialization" warning notifications for rows that transition
 */

export async function processMeStoppedNotifications({
  editedRow,
  editedRowOriginal,
  allAccessibleColumns,
  hasMeRole,
  screenGridId,
  createdBy,
  configSchema,
}: ProcessMeStoppedNotificationsParams): Promise<string | null> {

  if (!editedRow.length || !hasMeRole) {
    return null;
  }

  const { yesId, noId } = getMeDoneStateIds(allAccessibleColumns);

  if (yesId == null || noId == null) {
    return null; 
  }

  const meStoppedRows = getRowsTransitionedToMeDoneNo({
    editedRows: editedRow,
    editedRowsOriginal: editedRowOriginal,
    meDoneYesId: yesId,
    meDoneNoId: noId,
  });


  if (!meStoppedRows.length) {
    return null;
  }

  const valueOptionsProfitCenter = (allAccessibleColumns.find(
    (col) => col.attrInternalName === 'pf_lc',
  )?.valueOptions ?? []) as ProfitCenterOption[];

  try {
    await Promise.all(
      meStoppedRows.map((row) =>
        createMeStoppedIndustrializationNotification({
          row: row as any,
          screenGridId,
          createdBy,
          valueOptionsProfitCenter,
          configSchema,
        }),
      ),
    );
    return null;
  } catch (error) {
    return error instanceof Error ? error.message : 'Warning notification creation failed';
  }
}